import {WmWoundFinishedReason} from '../../interfaces/wound-management/wm-wound-finished-reason';

export class WmWoundFinishedReasonFactory {

  /**
   *
   * @param wmWoundFinishedReason
   */
  public static fromObject(wmWoundFinishedReason: any): WmWoundFinishedReason {
    return new class implements WmWoundFinishedReason {
      created: string = wmWoundFinishedReason.created;
      id: number = wmWoundFinishedReason.id;
      modified: string = wmWoundFinishedReason.modified;
      name: string = wmWoundFinishedReason.name;
      shortName: string = wmWoundFinishedReason.short_name;
      sort: number = wmWoundFinishedReason.sort;
      withOwnReason: boolean = wmWoundFinishedReason.with_own_reason;
    };
  }

  /**
   *
   * @param wmWoundFinishedReasons
   */
  public static fromArray(wmWoundFinishedReasons: any[]): WmWoundFinishedReason[] {
    return wmWoundFinishedReasons.map(
      wmWoundFinishedReason => WmWoundFinishedReasonFactory.fromObject(wmWoundFinishedReason)
    );
  }

}
